module.exports = __webpack_public_path__ + "static/media/markus.af5b5858.jpg";